import type { Effect, ResourceBundle } from '../engine';
import { formatNumber } from '../engine';
import { costLines, describeEffect } from './describe';

interface CostChipsProps {
  cost: ResourceBundle;
  held: Record<string, number>;
}

/** Cost pills that dim and strike through whatever the tribe cannot pay. */
export function CostChips({ cost, held }: CostChipsProps) {
  const lines = costLines(cost, held);
  if (lines.length === 0) return null;

  return (
    <div className="card-effects">
      {lines.map((line) => (
        <span
          key={line.resourceId}
          className={`effect-chip cost${line.affordable ? '' : ' short'}`}
        >
          {formatNumber(line.amount)} {line.name}
        </span>
      ))}
    </div>
  );
}

interface EffectChipsProps {
  effects: Effect[];
  level?: number;
}

export function EffectChips({ effects, level = 1 }: EffectChipsProps) {
  if (effects.length === 0) return null;

  return (
    <div className="card-effects">
      {effects.map((effect, index) => (
        <span key={index} className="effect-chip">
          {describeEffect(effect, level)}
        </span>
      ))}
    </div>
  );
}
